import LoadingSpinner from "components/LoadingIndicator/LoadingSpinner"

export default function Loading() {
  return (
    <div className="w-full h-full flex items-center justify-center min-h-screen">
      <div className="px-2 flex items-center justify-start gap-2">
        <LoadingSpinner className="text-primary-blue w-5 h-5" />
        <p className="text-base text-muted-foreground m-0 tracking-wider">
          Loading
        </p>
      </div>
    </div>
  )
}
